/**
 * Sticky Header — adds 'scrolled' class when page is scrolled
 * Used for transparent header fallback to opaque on scroll.
 */

export function initStickyHeader() {
	const header = document.querySelector( '.site-header' );
	if ( ! header ) return;

	const threshold = 80;

	const update = () => {
		header.classList.toggle( 'scrolled', window.scrollY > threshold );
	};

	window.addEventListener( 'scroll', update, { passive: true } );
	update(); // Run once on load.
}
